// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gQw7","questions":"styles_questions__16-rA","footer":"styles_footer__wJAYm"};